import { Address } from "./Address";
import { BaseEntity } from "./BaseEntity";
import { HARDWARE_LEVEL, HARDWARE_WEIGHTS } from "./Enums";

export interface Facility extends BaseEntity {
    name: string;
    contactPerson: string;
    contactEmail: string;
    contactPhone: string;
    contactMobile: string;
    dailyRate: number;
    comments: string;
    address: Address;
    rooms: FacilityRoom[];
};

export interface FacilityRoom extends BaseEntity {
    name: string;
    capacity: number;
    hardwareLevel: HARDWARE_LEVEL;
    dualMonitors: boolean;
    comments: string;
};

export const getFacilityCapabilities = (rooms?: FacilityRoom[]) => {
  // Return safe defaults if the array is empty or undefined
  if (!rooms || rooms.length === 0) {
    return {
      highestHardware: HARDWARE_LEVEL.NOT_APPLICABLE,
      hasDualMonitors: false,
    };
  }

  // 1. Explicitly pass the Type interface to the reduce function
  return rooms.reduce<{ highestHardware: HARDWARE_LEVEL; hasDualMonitors: boolean }>(
    (acc, currentRoom) => {
      // Now TypeScript knows these are strictly HARDWARE_LEVEL enums, never undefined
      const currentWeight = HARDWARE_WEIGHTS[currentRoom.hardwareLevel];
      const highestWeight = HARDWARE_WEIGHTS[acc.highestHardware];

      if (currentWeight > highestWeight) {
        acc.highestHardware = currentRoom.hardwareLevel;
      }

      if (currentRoom.dualMonitors) {
        acc.hasDualMonitors = true;
      }

      return acc;
    },
    // 2. Start the accumulator safely at the absolute minimum level instead of rooms[0]
    { 
      highestHardware: HARDWARE_LEVEL.NOT_APPLICABLE, 
      hasDualMonitors: false 
    }
  );
};